/* eslint-disable @typescript-eslint/no-explicit-any */
const HTTPS_REGEX = /^https?:\/\//

function checkIfImageExists(
  url: string,
  setImageUrl: any,
  fallbackUrl: string
) {
  const img = new Image()
  img.src = url

  if (img.complete) {
    img.onerror = null
    setImageUrl(url)
  } else {
    img.onerror = () => {
      setImageUrl(fallbackUrl)
    }
  }
}

function removeProtocolFromLink(url: string): string {
  if (url.includes('https://') || url.includes('http://')) {
    return url.replace(HTTPS_REGEX, '')
  }
  return url
}

function createResizeUrl(
  src: string,
  isResizeEnabled: boolean,
  dimensions?: string,
  resizeServiceUrl?: string
) {
  return isResizeEnabled
    ? `${resizeServiceUrl}/${dimensions}/${removeProtocolFromLink(src)}`
    : src
}

export { checkIfImageExists, removeProtocolFromLink, createResizeUrl }
